import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Template"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 4.5V7.5H4.5V4.5H19.5ZM19.5 3H4.5C3.67157 3 3 3.67157 3 4.5V7.5C3 8.32843 3.67157 9 4.5 9H19.5C20.3284 9 21 8.32843 21 7.5V4.5C21 3.67157 20.3284 3 19.5 3ZM7.5 12V19.5H4.5V12H7.5ZM7.5 10.5H4.5C3.67157 10.5 3 11.1716 3 12V19.5C3 20.3284 3.67157 21 4.5 21H7.5C8.32843 21 9 20.3284 9 19.5V12C9 11.1716 8.32843 10.5 7.5 10.5ZM19.5 12V19.5H12V12H19.5ZM19.5 10.5H12C11.1716 10.5 10.5 11.1716 10.5 12V19.5C10.5 20.3284 11.1716 21 12 21H19.5C20.3284 21 21 20.3284 21 19.5V12C21 11.1716 20.3284 10.5 19.5 10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Template.vue"]]);
